import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(): boolean | Observable<boolean | UrlTree> {
    if (this.auth.isLoggedIn()) return true;

    return this.auth.initializeSession().pipe(
      map((user) => (user ? true : this.router.createUrlTree(['/login']))),
      catchError(() => of(this.router.createUrlTree(['/login'])))
    );
  }
}
